/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { GridRows as ChartGridRowsCore } from '@visx/grid';
import { type ComponentProps, type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface ChartGridRowsProps
  extends Partial<
    Pick<
      ComponentProps<typeof ChartGridRowsCore>,
      'scale' | 'width' | 'children' | 'from' | 'left' | 'numTicks' | 'offset' | 'tickValues' | 'to' | 'top'
    >
  > {
  style?: stylex.StyleXStyles;
}

const ChartGridRowsContext = createContext<ContextValue<ChartGridRowsProps, SVGLineElement>>({});

const ChartGridRows = forwardRef((props: ChartGridRowsProps, ref: ForwardedRef<SVGLineElement>) => {
  [props, ref] = useContextProps(props, ref, ChartGridRowsContext);

  const { style, scale, width, ...coreProps } = props;

  return (
    <ChartGridRowsCore
      innerRef={ref}
      scale={scale!}
      width={width!}
      stroke="inherit"
      fill="red"
      {...stylex.props(styles.base, style)}
      {...coreProps}
    />
  );
});

const styles = stylex.create({
  base: {
    stroke: $.border06,
  },
});

export { ChartGridRows, ChartGridRowsContext, type ChartGridRowsProps };
